<template>
  <div class="video-pop-analysis">
    <div v-if="correctAnswer" class="analysis-label">
      <img class="label-icon" src="./assets/correct.svg" alt="" />
      <span>正确答案：</span>
      <span v-for="(answer, index) in correctAnswer" :key="index" class="mr-2">
        {{ answer }}
      </span>
    </div>
    <div v-else class="analysis-label">
      <img class="label-icon" src="./assets/analysis.svg" alt="" />
      <span>解析：</span>
    </div>

    <div v-if="analysis" class="analysis-content">
      {{ analysis }}
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class VideoPopAnalysis extends Vue {
  @Prop() correctAnswer!: string[];
  @Prop() analysis!: string;
}
</script>

<style lang="scss" scoped>
.video-pop-analysis {
  position: relative;
  padding-top: 22px;
  border-top: 1px solid #e8e9eb;
  .label-icon {
    flex-shrink: 0;
    width: 14px;
    margin-right: 5px;
  }
  .analysis-label {
    @apply flex items-center flex-wrap font-medium;
    margin-bottom: 5px;
    font-size: 14px;
    line-height: 20px;
  }
  .analysis-content {
    color: #808588;
    font-size: 13px;
    line-height: 20px;
  }
}
</style>
